import * as React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { GeneralAction } from "actions/general-action";
import { withRouter } from "../../../../helpers/withRouter";
import { Translation } from "react-i18next";
import { service } from "services/service";
import { EventAction } from "actions/event/event-action";
import { AuthAction } from "actions/auth/auth-action";
import { EventService } from "services/event/event-service";
import EventSideBar from "./EventSideBar";
import TemplateSideBar from "./TemplateSideBar";
import Loader from '@/app/forms/Loader';
import MenuItemComponents from "./MenuItemComponents";

const in_array = require("in_array");

const module_routes = {
  attendees: "/event/module/attendees",
  agendas: "/event/module/programs",
  speakers: "/event/module/speakers",
  infobooth: "/event/module/practical-information",
  additional_info: "/event/module/additional-information",
  general_info: "/event/module/general-information",
  maps: "/event/module/map",
  subregistration: "/event/module/sub-registration",
  ddirectory: "/event/module/documents",
};

class SideBarContainer extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      default_template_id:
        this.props.event !== undefined
          ? this.props.event.default_template_id
          : null,
      templateModules: "",
      event_id: localStorage.getItem("event_id"),
      editData: window.location.pathname.includes("/event/edit/")
        ? true
        : false,
      completed_modules: [],
      defaultModuleRoute: "/event/module/attendees",
      invitationStep: this.props.invitation.step,
      current_path: this.props.match.path,
      toggle: false,
      menuHierarchy: [],
      menuHierarchyLoaded: false, // Add loading state for menu hierarchy
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.state.event_id) {
      this.templates();
      this.progress();
      this.updateDefaultModuleRoute();
      this.getMenuHierarchy();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  static getDerivedStateFromProps(props, state) {
    if (state.current_path !== props.match.path) {
      return {
        event_id: props.event.id !== undefined ? props.event.id : "",
        editData: props.match.path.includes("/event/edit/"),
        invitationStep: props.invitation.step,
        current_path: props.match.path,
      };
    } else if (state.invitationStep !== props.invitation.step) {
      return {
        invitationStep: props.invitation.step,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.current_path !== this.state.current_path ||
      prevProps.redirect !== this.props.redirect
    ) {
      if (this.state.event_id) {
        this.progress();
      }
      if (prevState.event_id !== this.state.event_id && this.state.event_id) {
        this.templates();
        this.setState({ menuHierarchyLoaded: false }); // Reset loading state
        this.getMenuHierarchy();
      }
      this.updateDefaultModuleRoute();
    }
  }

  getMenuHierarchy() {
    if (this.state.event_id) {
      // First check localStorage for cached menu hierarchy
      const cachedMenuKey = `menuHierarchy_${this.state.event_id}`;
      const cachedMenu = localStorage.getItem(cachedMenuKey);
      
      if (cachedMenu) {
        try {
          const parsedMenu = JSON.parse(cachedMenu);
          if (this._isMounted) {
            this.setState({
              menuHierarchy: parsedMenu,
              menuHierarchyLoaded: true,
            });
          }
        } catch (error) {
          console.error('SideBarContainer - Error parsing cached menu hierarchy:', error);
          // If parsing fails, clear the cache and fetch fresh data
          localStorage.removeItem(cachedMenuKey);
        }
      }

      // Always fetch fresh data in the background to ensure we have the latest
      EventService.getMenuHierarchy(this.state.event_id).then(
        (response) => {
          if (response.success) {
            if (this._isMounted) {
              // Store in localStorage for future use
              localStorage.setItem(cachedMenuKey, JSON.stringify(response.data));
              
              this.setState({
                menuHierarchy: response.data,
                menuHierarchyLoaded: true,
              });
            }
          } else {
            // Handle unsuccessful response
            if (this._isMounted) {
              this.setState({
                menuHierarchyLoaded: true,
              });
            }
          }
        },
        (error) => {
          console.error("Menu Hierarchy API Error:", error);
          // Handle error case
          if (this._isMounted) {
            this.setState({
              menuHierarchyLoaded: true,
            });
          }
        }
      );
    }
  }

  // Method to clear cached menu hierarchy when returning to list
  clearCachedMenuHierarchy() {
    if (this.state.event_id) {
      const cachedMenuKey = `menuHierarchy_${this.state.event_id}`;
      localStorage.removeItem(cachedMenuKey);
      console.log('SideBarContainer - Cleared cached menu hierarchy for event:', this.state.event_id);
    }
  }

  isMenuItemAvailable(alias) {
    // If we're on the create route, allow all menu items
    const isCreateRoute = window.location.pathname.includes("/event/create") || 
                         window.location.pathname.includes("create");
    if (isCreateRoute) {
      return true;
    }

    if (!this.state.menuHierarchyLoaded) {
      // console.log(`Menu hierarchy not loaded, denying ${alias}`);
      return false;
    }

    if (!this.state.menuHierarchy || this.state.menuHierarchy.length === 0) {
      // console.log(`Menu hierarchy is empty, denying ${alias}`);
      return false;
    }

    const mainMenuItem = this.state.menuHierarchy.find(
      (item) => item.alias === alias
    );
    if (mainMenuItem && mainMenuItem.status === 1) {
      // console.log(`Found main menu item ${alias} with status 1`);
      return true;
    }

    for (const menuItem of this.state.menuHierarchy) {
      if (menuItem.children && menuItem.children.length > 0) {
        const childMenuItem = menuItem.children.find(
          (child) => child.alias === alias
        );
        if (childMenuItem && childMenuItem.status === 1) {
          // console.log(`Found child menu item ${alias} under ${menuItem.alias} with status 1`);
          return true;
        }
      }
    }

    // console.log(
    //   `Menu item with alias '${alias}' not found in API response or status is not active`
    // );
    // console.log(
    //   "Available menu items in API:",
    //   this.state.menuHierarchy.map((item) => ({
    //     alias: item.alias,
    //     name: item.name,
    //     children: item.children
    //       ? item.children.map((child) => ({
    //           alias: child.alias,
    //           name: child.name,
    //           status: child.status,
    //         }))
    //       : [],
    //   }))
    // );
    return false;
  }

  isParentMenuAvailable(parentAlias) {
    // If we're on the create route, allow all parent menu items
    const isCreateRoute = window.location.pathname.includes("/event/create") || 
                         window.location.pathname.includes("create");
    if (isCreateRoute) {
      return true;
    }

    if (!this.state.menuHierarchyLoaded) {
      // console.log(`Menu hierarchy not loaded, denying parent menu ${parentAlias}`);
      return false;
    }

    if (!this.state.menuHierarchy || this.state.menuHierarchy.length === 0) {
      return false;
    }

    const parentMenuItem = this.state.menuHierarchy.find(
      (item) => item.alias === parentAlias
    );
    if (!parentMenuItem || parentMenuItem.status !== 1) {
      return false;
    }

    if (!parentMenuItem.children || parentMenuItem.children.length === 0) {
      return true;
    }

    return parentMenuItem.children.some((child) => child.status === 1);
  }

  isChildMenuItemAvailable(parentAlias, childAlias) {
    // If we're on the create route, allow all child menu items
    const isCreateRoute = window.location.pathname.includes("/event/create") || 
                         window.location.pathname.includes("create");
    if (isCreateRoute) {
      return true;
    }

    if (!this.state.menuHierarchyLoaded) {
      // console.log(`Menu hierarchy not loaded, denying child menu ${childAlias}`);
      return false;
    }

    if (!this.state.menuHierarchy || this.state.menuHierarchy.length === 0) {
      return false;
    }

    const parentMenuItem = this.state.menuHierarchy.find(
      (item) => item.alias === parentAlias
    );

    if (!parentMenuItem || parentMenuItem.status !== 1) {
      return false;
    }

    if (parentMenuItem.children && parentMenuItem.children.length > 0) {
      const childMenuItem = parentMenuItem.children.find(
        (child) => child.alias === childAlias
      );
      return childMenuItem && childMenuItem.status === 1;
    }

    return false;
  }

  getSortedParentMenus() {
    // If we're on the create route, return default menu list
    const isCreateRoute = window.location.pathname.includes("/event/create") || 
                         window.location.pathname.includes("create");
    if (isCreateRoute) {
      return [
        "event_details",
        "branding",
        "items_paid",
        "registration_list",
        "online_registration_form",
        "upload_content",
        "survey",
      ];
    }

    if (!this.state.menuHierarchyLoaded) {
      return [];
    }

    if (!this.state.menuHierarchy || this.state.menuHierarchy.length === 0) {
      return [];
    }

    return this.state.menuHierarchy
      .filter((item) => item.status === 1)
      .sort((a, b) => {
        const sortOrderA = a.sort_order || 999;
        const sortOrderB = b.sort_order || 999;
        return sortOrderA - sortOrderB;
      })
      .map((item) => item.alias);
  }

  getParentMenuSortOrder(alias) {
    const sortedMenus = this.getSortedParentMenus();
    const index = sortedMenus.indexOf(alias);
    return index >= 0 ? index : 999;
  }

  getParentMenuDisplayNumber(alias) {
    const sortedMenus = this.getSortedParentMenus();
    // For free events, registration_list should use the same number as items_paid would use
    // Check both aliases and use whichever exists in the sorted menus
    let searchAlias = alias;
    if (alias === "registration_list") {
      // Try items_paid first (for paid events), fallback to registration_list (for free events)
      searchAlias = sortedMenus.indexOf("items_paid") >= 0 ? "items_paid" : "registration_list";
    }
    let index = sortedMenus.indexOf(searchAlias);
    
    // If not found in sorted menus, check menu hierarchy directly to get position based on sort_order
    if (index < 0 && this.state.menuHierarchy && this.state.menuHierarchy.length > 0) {
      const menuItem = this.state.menuHierarchy.find(item => item.alias === searchAlias);
      if (menuItem) {
        // Count how many active items come before this one based on sort_order
        const sortOrder = menuItem.sort_order || 7;
        index = this.state.menuHierarchy
          .filter(item => item.status === 1 && (item.sort_order || 7) < sortOrder)
          .length;
      }
    }
    
    return index >= 0 ? index + 1 : 7;
  }

  templates() {
    service.get(`${process.env.REACT_APP_URL}/template/listing`).then(
      (response) => {
        if (response.success) {
          if (this._isMounted) {
            this.setState(
              {
                templateModules: response.data,
                default_template_id: response.data.default_template_id,
              },
              () => {
                this.props.event.templateIds = response.data.templateIds;
                this.props.dispatch(EventAction.eventInfo(this.props.event));
              }
            );
          }
        }
      },
      (error) => {}
    );
  }

  updateDefaultModuleRoute() {
    if (this.state.event_id) {
      if (
        this.props.event.modules !== undefined &&
        this.props.event.modules.length > 0
      ) {
        let modules = this.props.event.modules.filter(function (module, i) {
          return (
            (!in_array(module.alias, ["polls"]) &&
              Number(module.status) === 1) ||
            in_array(module.alias, ["subregistration"])
          );
        });
        if (Number(this.props.event.is_app) === 1) {
          this.setState({
            defaultModuleRoute: "/event/module/event-module-order",
          });
        } else if (Number(this.props.event.is_registration) === 1) {
          this.setState({
            defaultModuleRoute: "/event/module/eventsite-module-order",
          });
        } else {
          this.setState({
            defaultModuleRoute:
              modules[0] !== undefined &&
              module_routes[modules[0]["alias"]] !== undefined
                ? module_routes[modules[0]["alias"]]
                : "/event/manage/surveys",
          });
        }
      }
    }
  }

  progress() {
    service.get(`${process.env.REACT_APP_URL}/event/progress`).then(
      (response) => {
        if (response.success) {
          if (this._isMounted) {
            if (response.data) {
              this.setState({
                completed_modules: response.data.modules,
              });
            }
          }
        }
      },
      (error) => {}
    );
  }

  handleToggle = () => {
    this.setState(prevState => ({
      toggle: !prevState.toggle
    }));
  }

  render() {
    const { event_id } = this.state;
    
    return (
      <Translation>
        {(t) => (
          <div className="row d-flex">
            <div className="col-3">
              {this.renderSidebar(t, event_id)}
            </div>
            <div className="col-9">{this.props.children}</div>
          </div>
        )}
      </Translation>
    );
  }

  renderSidebar(t, event_id) {
    // Show loading indicator while menu hierarchy is being fetched
    // BUT: If we're on the create event route, show all menus immediately
    const pathname = window.location.pathname;
    const isCreateRoute = pathname.includes("/event/create") || pathname.includes("create");
    const isEventEditRoute = pathname.includes("/event/edit/");
    const shouldWaitForMenuHierarchy = isEventEditRoute && !isCreateRoute;
    if (!this.state.menuHierarchyLoaded && shouldWaitForMenuHierarchy) {
      return (
        <div className="app-side-application">
          <div className="sidebar-loading">
            <Loader />
            <p style={{ textAlign: 'center', marginTop: '10px', color: '#666' }}>
              Loading menu configuration...
            </p>
          </div>
        </div>
      );
    }

    const sidebarProps = {
      ...this.props,
      ...this.state,
      t,
      event_id,
      isMenuItemAvailable: this.isMenuItemAvailable.bind(this),
      isParentMenuAvailable: this.isParentMenuAvailable.bind(this),
      isChildMenuItemAvailable: this.isChildMenuItemAvailable.bind(this),
      getParentMenuSortOrder: this.getParentMenuSortOrder.bind(this),
      getParentMenuDisplayNumber: this.getParentMenuDisplayNumber.bind(this),
      module_routes,
      onToggle: this.handleToggle,
      clearCachedMenuHierarchy: this.clearCachedMenuHierarchy.bind(this),
    };

    // Event SideBar (Main sidebar for event editing)
    if (
      !window.location.pathname.includes("/event/template/") &&
      !window.location.pathname.includes("/event/invitation/send-invitation") &&
      !window.location.pathname.includes("/account/organizer/") &&
      !window.location.pathname.includes("/account/change-password")
    ) {
      return <EventSideBar {...sidebarProps} />;
    }

    // Template SideBar
    if (window.location.pathname.includes("/event/template/")) {
      return <TemplateSideBar {...sidebarProps} />;
    }

    // Invitation SideBar
    if (window.location.pathname.includes("/event/invitation/send-invitation")) {
      return (
        <div className="app-side-application">
          <div className="btn-return-navigation">
            <NavLink
              to={`/event/edit/${event_id}`}
              onClick={() => {
                this.props.dispatch(GeneralAction.step(1));
              }}
            >
              <i className="material-symbols-outlined">arrow_back</i>
              {t("M_RETURN_TO_EDIT_EVENT")}
            </NavLink>
          </div>
          <ul>
            <li className={`${!this.props.invitation.module ? 'bold activeList' : ''} ${this.state.invitationStep >= 1 ? 'completed' : ''}`}>
              <span>
                <a style={{ cursor: 'pointer' }} onClick={() => { this.props.dispatch(EventAction.invitation(null)); this.props.history.push(`/event/invitation/send-invitation`); }}>
                  {t('M_CREATE_INVITE')}
                </a>
              </span>
              <ul>
                <li>
                  <span onClick={() => this.props.dispatch(EventAction.invitation(null))} className="activeCompleted">{t('M_SELECT_INVITE_TYPE')}</span>
                </li>
              </ul>
            </li>

            <li className={`${this.state.invitationStep === 1 ? 'bold activeList' : ''} ${this.state.invitationStep >= 2 ? 'completed' : ''}`}>
              {this.state.invitationStep > 1 ? (
                <span>
                  <a style={{ cursor: 'pointer' }} onClick={() => { this.props.invitation.step = 1; this.props.dispatch(EventAction.invitation(this.props.invitation)); this.props.history.push(`/event/invitation/send-invitation/1`); }}>
                    {t('M_EDIT_EMAIL')}
                  </a>
                </span>
              ) : (
                <span>{t('M_EDIT_EMAIL')}</span>
              )}
            </li>

            <li className={`${this.state.invitationStep === 2 ? 'bold activeList' : ''} ${this.state.invitationStep >= 3 ? 'completed' : ''}`}>
              {this.state.invitationStep > 2 ? (
                <span>
                  <a style={{ cursor: 'pointer' }} onClick={() => { this.props.invitation.step = 2; this.props.dispatch(EventAction.invitation(this.props.invitation)); this.props.history.push(`/event/invitation/send-invitation/2`); }}>
                    {t('M_UPLOAD_UPDATE_GUEST_LIST')}
                  </a>
                </span>
              ) : (
                <span>{t('M_UPLOAD_UPDATE_GUEST_LIST')}</span>
              )}
            </li>

            <li className={`lastItem ${this.state.invitationStep === 3 ? 'bold activeList' : ''} ${this.state.invitationStep >= 4 ? 'completed' : ''}`}>
              <span style={{ cursor: 'pointer' }}>{t('M_PREVIEW_SEND_EMAIL')}</span>
            </li>
          </ul>
        </div>
      );
    }


      // Organizer Profile SideBar
      if (window.location.pathname.includes('/account/organizer/')) {
        return (
          <div className="app-side-application app-application-setting">
            <div className="btn-return-navigation">
              <NavLink 
                to={`/`} 
                onClick={() => { 
                  this.props.dispatch(GeneralAction.step(1)); 
                }}
              >
                <i className='material-symbols-outlined'>arrow_back</i>
                {t('M_RETURN_TO_MAIN')}
              </NavLink>
            </div>
            <ul>
              <li>
                <NavLink to="/account/organizer/profile">
                  <img alt={t('M_MY_ACCOUNT')} src={require('img/ico-user.svg')} />
                  <span> {t('M_MY_ACCOUNT')}</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/account/organizer/change-password">
                  <img alt={t('M_CHANGE_PASSWORD')} src={require('img/ico-lock-lg.svg')} />
                  <span>{t('M_CHANGE_PASSWORD')}</span>
                </NavLink>
              </li>
              <li>
                <a href="#!" onClick={(e) => { e.preventDefault(); AuthAction.logout(); }}>
                  <span className="icons">
                    <img alt={t('LOGOUT')} src={require('img/ico-logout.svg')} />
                  </span>
                  {t('LOGOUT')}
                </a>
              </li>
            </ul>
          </div>
        );
      }
  

    // Default return null
    return null;
  }
}

function mapStateToProps(state) {
  const { eventStep, event, invitation, eventState, redirect } = state;
  return {
    eventStep,
    event,
    invitation,
    eventState,
    redirect,
  };
}

export default connect(mapStateToProps)(withRouter(SideBarContainer)); 